import {
  LitElement,
  html,
  css,
} from "https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js";

export class LookbookProduct extends LitElement {
  static properties = {
    title: {},
    handle: {},
    price: {},
    image: {},
  };

  static styles = css`
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .lookbook-product__info {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 10px 22px;
      box-sizing: border-box;
    }

    .lookbook-product__button {
      text-decoration: none;
    }

    .lookbook-product__title {
      display: flex;
      flex-direction: column;
      color: #000;
      font-family: Genath;
      font-size: 18px;
      font-weight: 300;
      line-height: 1.2;
    }
      
    .lookbook-product__title-text {
        width: 100%;
        @media screen and (min-width: 768px) {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }  

    .lookbook-product__price {
      color: #5f5f5f;
      font-family: Genath;
      font-size: 18px;
      font-style: normal;
      font-weight: 300;
      line-height: 1.2;
      letter-spacing: 0.2px;
    }

    img {
      width: 100%;
      height: auto;
      display: block;
      aspect-ratio: 2 / 3;
    }

    .desktop-layout {
      height: 100%;
    }

    .desktop-layout .lookbook-product__info {
      padding: 24px 32px;
    }

    .desktop-layout img {
      width: auto;
      height: 100%;
    }
  `;

  constructor() {
    super();
  }

  isMobile() {
    return window.innerWidth < 768 || window.innerWidth < window.innerHeight;
  }

  firstUpdated() {
    if (!this.isMobile()) {
      this.updateHeight();
    }
  }

  updateHeight() {
    const parentElement = this.parentElement;
    const parentHeight = parentElement.offsetHeight;
    const text = this.shadowRoot.querySelector(".lookbook-product__info");
    const image = this.shadowRoot.querySelector(".lookbook-product__image");
    if (image) {
      setTimeout(() => {
        text.style.maxWidth = `${image.offsetWidth}px`;
      }, 200);
    }
    const textHeight = text.offsetHeight;
    const calculatedHeight = parentHeight - textHeight;
    this.style.height = `${calculatedHeight}px`;
  }

  render() {
    const productTitle = this.title;
    const productURL =
      window.location.protocol +
      "//" +
      window.location.host +
      "/products/" +
      this.handle;
    let productTitleMarkup = html`${productTitle}`;
    if (productTitle.includes("-")) {
      const productTitleFirst = productTitle.split("-")[0].trim();
      const productTitleLast = productTitle.split("-")[1].trim();
      productTitleMarkup = html`<div class="lookbook-product__title-text">${productTitleFirst}</div>
        <em>${productTitleLast}</em>`;
    }

    return html`
      <div
        class="lookbook-product__container ${!this.isMobile()
          ? "desktop-layout"
          : ""}"
      >
        <a href="${productURL}">
          <img class="lookbook-product__image" src=${this.image} />
        </a>
        <div class="lookbook-product__info">
          <a href="${productURL}" class="lookbook-product__button"
            ><div class="lookbook-product__title">${productTitleMarkup}</div>
          </a>
          <div class="lookbook-product__price">${this.price}</div>
        </div>
      </div>
    `;
  }
}

customElements.define("lookbook-product", LookbookProduct);
